module.exports = __webpack_public_path__ + "img/accessory_shoe_06.9d1aadc9.svg";